import { G } from '@mobily/ts-belt';
import { isAxiosError, type AxiosError, type AxiosResponse } from 'axios';
import type { ResponseError } from '../types';
export type ValidateEmailRequestParameters = {
  email: string;
};
type ValidateEmailResponseOk = {
  valid: true;
  status: 200;
};
type ValidateEmailResponseExisting = {
  valid: false;
  status: 200;
};
export type ValidateEmailResponse = ValidateEmailResponseOk | ValidateEmailResponseExisting;
export const isValidateEmailResponseExisting = (validateEmailResponse: ValidateEmailResponse): validateEmailResponse is ValidateEmailResponseExisting => G.isBoolean(validateEmailResponse?.valid) && !validateEmailResponse.valid;

// ======
// Errors
// ======

export interface ValidateEmailError extends AxiosError {
  response: AxiosResponse<ResponseError>;
}
const isValidateEmailResponseError = (response: AxiosResponse): response is ValidateEmailError['response'] => response.status !== 200;

/**
 * Axios doesn't surface an easy way to type errors with generics. This
 * strategy is taken from an [Github issue comment](https://github.com/axios/axios/issues/3612#issuecomment-1294232173).
 */
export const isValidateEmailError = (error: unknown): error is ValidateEmailError => isAxiosError(error) && G.isObject(error.response) && isValidateEmailResponseError(error.response);